import React from 'react'
import { Paper, useTheme } from '@mui/material'
import Text from '../../Text'
import { corLegivel } from '../../../libs/corLegivel'

// Card de KPI — número em destaque, ícone com cor de acento e legenda. Skeleton
// enquanto carrega. Compartilhado entre o relatório de envios e o do SmartFilter.
//
// `compact` é a variante usada no relatório de envios, onde os números disputam
// espaço com as ações e a lista de mensagens: o cartão perde quase metade da
// altura trocando o ícone em quadrado por uma faixa vertical da mesma cor. O
// estado continua legível de relance — que é o papel do ícone ali — sem custar
// tela. Sem a prop, o cartão é o de sempre.
export default function KpiCard({ label, value, hint, icon, accent, loading, compact = false }) {
  const theme = useTheme()
  const valorFormatado = typeof value === 'number' ? value.toLocaleString('pt-BR') : value
  // O número grande usa a cor de destaque, ajustada pra ser lida no tema atual
  // (o ciano da marca sobre branco ficava ilegível). A faixa/ícone seguem na
  // cor original — ali ela é preenchimento, não texto.
  const corDoValor = corLegivel(accent, theme.palette.background.paper, 3)

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: compact ? '12px' : '14px',
        border: theme.isDark ? '1px solid #334155' : '1px solid #e2e8f0',
        overflow: 'hidden',
        height: '100%',
      }}
    >
      {
        compact
        ? (
          <div className="flex items-stretch gap-3 h-full p-3">
            <span className="w-[3px] shrink-0 rounded-full" style={{ background: accent }} />
            <div className="min-w-0 flex flex-col justify-center">
              <Text className="text-[11px] font-semibold uppercase tracking-wider opacity-50">{label}</Text>
              {
                loading
                ? <div className="mt-1 h-6 w-16 rounded bg-current opacity-10 animate-pulse" />
                : <Text className="text-2xl font-black leading-none" style={{ color: corDoValor }}>
                    {valorFormatado}
                  </Text>
              }
              {hint && <Text className="text-[11px] opacity-60 mt-1 block truncate">{hint}</Text>}
            </div>
          </div>
        )
        : (
          <div className="p-5 flex items-start justify-between gap-3 h-full">
            <div className="min-w-0">
              <Text className="text-xs font-semibold uppercase tracking-wider opacity-50">{label}</Text>
              {
                loading
                ? <div className="mt-2 h-8 w-20 rounded bg-current opacity-10 animate-pulse" />
                : <Text className="text-3xl md:text-4xl font-black mt-1 leading-none" style={{ color: corDoValor }}>
                    {valorFormatado}
                  </Text>
              }
              {hint && <Text className="text-xs opacity-60 mt-2 block">{hint}</Text>}
            </div>
            {
              icon &&
              <div
                className="shrink-0 rounded-xl flex items-center justify-center"
                style={{ width: 44, height: 44, background: `${accent}1a`, color: accent }}
              >
                {icon}
              </div>
            }
          </div>
        )
      }
    </Paper>
  )
}
